import React from "react";

import ForgotPasswordScreen from "@/screens/Authentication/ForgotPasswordScreen";

export default function Main(): React.JSX.Element {
  return <ForgotPasswordScreen />;
}
